import types from './types';
import {prepare} from '~/misc/create';

export const toggleDropdown = prepare(types.TOGGLE_DROPDOWN);
export const openDropdown = prepare(types.OPEN_DROPDOWN);
export const closeDropdown = prepare(types.CLOSE_DROPDOWN);



// WEBPACK FOOTER //
// ./src/modules/dropdowns/actions.js